import { Avatar, Dropdown, Layout, MenuProps, Select } from "antd";
import { LogOut, User } from "react-feather";
import { Link } from "react-router";
import { useAuth } from "../../context/AuthContext";
import StoreContextSelector from "../../components/stores/StoreContextSelector";

const Header = () => {
  const { Header } = Layout;
  const { logout, user } = useAuth();

  const items: MenuProps["items"] = [
    {
      label: <Link to={"/profile"}>Profile</Link>,
      key: "0",
      icon: <User size={15} />,
    },
    {
      label: "Logout",
      key: "3",
      icon: <LogOut size={15} />,
      danger: true,
      onClick: logout,
    },
  ];

  return (
    <Header
      style={{ background: "#fff", padding: "0 20px" }}
      className="border-b border-b-gray-300"
    >
      <div className="flex justify-end items-center w-full h-full gap-6">
        <StoreContextSelector />
        <Dropdown menu={{ items }} trigger={["click"]}>
          <Avatar className="cursor-pointer">A</Avatar>
        </Dropdown>
      </div>
    </Header>
  );
};

export default Header;
